<template>
  <div>
    <div class="switch-date-bar">
      <div class="date-tool">
        <i class="icon-chevron-back" />
        <p>2020.05</p>
        <i class="icon-chevron-forward" />
      </div>
      <WsButton001>
        今天
      </WsButton001>
    </div>
    <div class="year-calendar">
      <div class="calendar-item-wrap">
        <p class="small">
          1月
        </p>
        <div class="item-content">
          <div class="square-card-list">
            <div class="card">
              <SquareCard />
            </div>
            <div class="card tabletHide">
              <SquareCard />
            </div>
            <div class="card">
              <SquareCard />
            </div>
          </div>
          <div class="item-list">
            <div class="item">
              <p>2020.01.15</p>
              <i class="icon-extension-outline" />
              <p>廢棄物清理計畫書</p>
            </div>
            <div class="item">
              <p>2020.01.15</p>
              <i class="icon-extension-outline" />
              <p>廢棄物清理計畫書</p>
            </div>
            <div class="item">
              <p>2020.01.15</p>
              <i class="icon-extension-outline" />
              <p>廢棄物清理計畫書</p>
            </div>
          </div>
        </div>
      </div>
      <div class="calendar-item-wrap">
        <p class="small">
          1月
        </p>
        <div class="item-content">
          <div class="square-card-list">
            <div class="card">
              <SquareCard />
            </div>
            <div class="card tabletHide">
              <SquareCard />
            </div>
            <div class="card">
              <SquareCard />
            </div>
          </div>
          <div class="item-list" />
        </div>
      </div>
      <div class="calendar-item-wrap">
        <p class="small">
          1月
        </p>
        <div class="item-content">
          <div class="square-card-list">
            <div class="card">
              <SquareCard />
            </div>
            <div class="card tabletHide">
              <SquareCard />
            </div>
            <div class="card">
              <SquareCard />
            </div>
          </div>
          <div class="item-list">
            <div class="item">
              <p>2020.01.15</p>
              <i class="icon-extension-outline" />
              <p>廢棄物清理計畫書</p>
            </div>
            <div class="item">
              <p>2020.01.15</p>
              <i class="icon-extension-outline" />
              <p>廢棄物清理計畫書</p>
            </div>
            <div class="item">
              <p>2020.01.15</p>
              <i class="icon-extension-outline" />
              <p>廢棄物清理計畫書</p>
            </div>
            <div class="item">
              <p>2020.01.15</p>
              <i class="icon-extension-outline" />
              <p>廢棄物清理計畫書</p>
            </div>
            <div class="item">
              <p>2020.01.15</p>
              <i class="icon-extension-outline" />
              <p>廢棄物清理計畫書</p>
            </div>
            <div class="item">
              <p>2020.01.15</p>
              <i class="icon-extension-outline" />
              <p>廢棄物清理計畫書</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "YearCalendar",
};
</script>
<style lang="scss" scoped>
.switch-date-bar {
  @include flex_align;
  justify-content: center;
  position: relative;
  height: 36px;
  .date-tool {
    @include flex;
    color: var(--blue-500);
    p {
      @include auto_margin_left(20px);
      font-size: 1.125rem;
      font-weight: bold;
      line-height: 1.33;
    }
    i {
      @include auto_margin_left(20px);
      font-size: 24px;
      cursor: pointer;
    }
  }
  .gradient-button {
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    height: 36px;
    &::before {
      width: 100px;
      height: 36px;
    }
  }
}
.year-calendar {
  @include auto_margin_top(8px);
  padding: 0 40px;
  border-radius: 20px;
  background-color: var(--white);
  @media screen and (max-width: 1023px) {
    padding: 0 20px;
  }
  .calendar-item-wrap {
    @include flex;
    align-items: flex-start;
    padding: 30px 0;
    border-top: 1px solid var(--blue-50);
    &:first-child {
      border-top: none;
    }
    p {
      font-size: 1.125rem;
      line-height: 1.33;
      white-space: nowrap;
      color: var(--gray-900);
      &.small {
        font-size: 1rem;
      }
    }
    .item-content {
      @include auto_margin_left(20px);
      @include flex;
      align-items: flex-start;
      width: 100%;
      @media screen and (max-width: 1023px) {
        flex-direction: column;
      }
      .square-card-list {
        @include flex_align;
        @media screen and (max-width: 1023px) {
          width: 100%;
        }
        .card {
          @include auto_margin_left(10px);
          width: 140px;
          @media screen and (max-width: 1023px) {
            width: calc((100% - 10px) / 2);
          }
          &.tabletHide {
            @media screen and (max-width: 1023px) {
              display: none;
            }
          }
        }
      }
      .item-list {
        @include auto_margin_left(20px);
        @media screen and (max-width: 1023px) {
          @include auto_margin_left(0px);
          @include auto_margin_top(20px);
          flex-direction: column;
        }
        .item {
          @include auto_margin_top(10px);
          @include flex_align;
          padding: 5px 10px;
          border-radius: 8px;
          background-color: var(--white);
          cursor: pointer;
          &:hover {
            box-shadow: 0 2px 12px -4px rgba(0, 0, 0, 0.4);
          }
          @media screen and (max-width: 1023px) {
            box-shadow: 0 2px 12px -4px rgba(0, 0, 0, 0.4);
          }
          i {
            @include auto_margin_left(20px);
            font-size: 1.5rem;
            color: var(--gray-900);
          }
          p {
            @include auto_margin_left(4px);
          }
        }
      }
    }
  }
}
</style>